import React from 'react';
import { Grid, Typography } from '@mui/material';

import ViewListPaginated from '../../page-layouts/view/list/ViewList';
import { GridListItem, type ItemLayoutProps } from '../../GridList';
import Text from '../../Text';

interface TemplateStepProps {
	module: string;
	selectedTemplates?: any[];
}

function TemplateListItem(props: ItemLayoutProps) {
	return (
		<GridListItem>
			<Grid container>
				<Grid size={12}>
					<Typography variant="subtitle2">{props.model.impt_title}</Typography>
				</Grid>
				<Grid size={12}>
					<Text className="text-10" variant="subtitle2" color="text.secondary">
						{props.model.impt_storedprocedure}
					</Text>
				</Grid>
				<Grid size={12}>
					<Typography variant="body1">{props.model.impt_description}</Typography>
				</Grid>
			</Grid>
		</GridListItem>
	);
}

export default function TemplateStep(props: TemplateStepProps) {
	return (
		<ViewListPaginated
			module="sys_importables_templates"
			itemLayout={TemplateListItem}
			defaultFilters={[{ filt_field: 'impt_module', filt_clause: 'equals', filt_value: props.module }]}
			selectionProps={{ mode: 'multiple', selectedItems: props.selectedTemplates || [] }}
			showExportButton={false}
		/>
	);
}
